import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'

import { useAppSelector } from 'app/state'
import settings from 'settings'
import { useLocation } from 'react-router-dom'

function isUserBlockedError(error: Error) {
  return /blocked|suspended/i.test(error.message)
}

function isUnverifiedEmailError(error: Error) {
  return error.message && error.message.includes('[401001]')
}

function isUnauthorizedError(error: Error) {
  return error.message && error.message.includes('Unauthorized')
}

function isInvalidDomainError(error: Error) {
  return error.message && error.message.includes('[401002]')
}

function useAuthenticationError() {
  const { error } = useAuth0()
  const location = useLocation()
  const meError = useAppSelector((state) => state.users.meError)
  const hasError = error || meError
  const isBQOauthCallbackRoute = location.pathname.match(/^\/connections\/bigquery\/oauth/)

  useEffect(() => {
    if (isBQOauthCallbackRoute) {
      return
    }

    // Managed login errors:
    if (meError) {
      if (isUserBlockedError({ message: meError.error } as Error)) {
        window.location.replace(`${settings.accountsUrl}/user/blocked`)
        return
      }
    }

    if (error) {
      if (isUserBlockedError(error)) {
        window.location.replace(`${settings.accountsUrl}/user/blocked`)
        return
      }

      if (isUnverifiedEmailError(error)) {
        window.location.replace(`${settings.accountsUrl}/user/verify`)
        return
      }

      if (isInvalidDomainError(error)) {
        window.location.replace(`${settings.accountsUrl}/user/invalid_domain`)
        return
      }

      if (isUnauthorizedError(error)) {
        window.location.replace(`${settings.accountsUrl}/user/unauthorized`)
        return
      }

      window.location.replace(`${settings.accountsUrl}/user/invalid_request`)
      return
    }
  }, [error, meError, isBQOauthCallbackRoute])

  return hasError
}

export default useAuthenticationError
